import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const tableStyles = style({
  width: "100%",
  borderCollapse: "collapse",
  whiteSpace: "nowrap",
});

export const tableWrapper = style({
  position: "relative",
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.surface,
  padding: `0 0 ${vars.space.s} 0`,
  maxHeight: 300,
  overflow: "auto",
  fontSize: vars.fontSizes.body.s,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      maxHeight: 500,
    },
  },
});

export const tHead = style({
  position: "sticky",
  zIndex: vars.zIndex.table.stickyHead,
  top: 0,
  backgroundColor: vars.colors.surface,
});

export const tableCell = style({
  position: "relative",
  borderBottom: `1px solid ${vars.colors.outlineVariant}`,
  paddingBlockStart: vars.space.s,
  paddingBlockEnd: vars.space.s,
  paddingInlineStart: vars.space.s,
  paddingInlineEnd: vars.space["2xs"],
  color: vars.colors.onSurface,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      padding: `${vars.space.s} ${vars.space.m}`,
    },
  },
});

export const headerCell = style({
  backgroundColor: vars.colors.surface,
  paddingBlockStart: vars.space.s,
  paddingBlockEnd: vars.space.s,
  paddingInlineStart: vars.space.s,
  paddingInlineEnd: vars.space["2xs"],
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.heading.xs,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      padding: `${vars.space.s} ${vars.space.m}`,
    },
  },
  selectors: {
    "&:first-child": {
      textAlign: "start",
    },
    "&:last-child": {
      paddingInlineEnd: 16,
    },
  },
});

export const leftAlignedCell = style([
  headerCell,
  {
    textAlign: "start",
  },
]);

export const stickyHeaderCell = style([
  headerCell,
  {
    position: "sticky",
    zIndex: vars.zIndex.table.stickyHead,
    insetInlineStart: 0,
  },
]);

export const stickyTableCell = style([
  tableCell,
  {
    position: "sticky",
    zIndex: vars.zIndex.table.stickyCol,
    insetInlineStart: 0,
    backgroundColor: vars.colors.surface,
  },
]);

export const totalsCell = style([
  tableCell,
  {
    fontFamily: vars.fonts.bold,
  },
]);

export const totalsHeaderCell = style([
  stickyTableCell,
  {
    textAlign: "end",
    fontFamily: vars.fonts.bold,
  },
]);
